import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function WhoIsItFor() {
  const cards = [{
    icon: '👨‍👩‍👧',
    title: 'Familias',
    description: 'Tenés un familiar sordo y la comunicación siempre quedó a medias. Con LSA Fácil van a poder tener conversaciones reales — no solo gestos.',
    bullets: ['Vocabulario de familia, emociones y vida cotidiana', 'Frases para el día a día']
  }, {
    icon: '🏫',
    title: 'Docentes y colegios',
    description: 'Tenés un alumno sordo y dependés del intérprete para todo. Con LSA Fácil vas a poder darle la consigna, corregirlo y conectar directamente.',
    bullets: ['Vocabulario escolar y consignas de examen', 'Señas para rutinas del aula']
  }, {
    icon: '📝',
    title: 'Traductores e intérpretes',
    description: 'Tenés base en LSA pero el vocabulario técnico no está en ningún lado. El Plan Profesional te da los módulos de Salud, Legal y Banca validados para 2026.',
    bullets: ['Módulos especializados por área', 'Terminología técnica en LSA argentino']
  }];
  return <section className="bg-lsa-dark text-white py-16 px-5" data-id="element-308">
      <div className="max-w-xl mx-auto" data-id="element-309">
        <h2 className="text-[28px] font-bold text-center mb-10 leading-tight" data-id="element-310">
          ¿Este sistema es para vos?
        </h2>

        <div className="flex flex-col gap-6" data-id="element-311">
          {cards.map((card, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white/5 border border-white/10 p-6 rounded-2xl" data-id="element-312">
              <div className="flex items-center gap-3 mb-4" data-id="element-313">
                <span className="text-2xl" data-id="element-314">{card.icon}</span>
                <h3 className="text-xl font-bold text-lsa-celeste" data-id="element-315">
                  {card.title}
                </h3>
              </div>

              <p className="text-white/80 text-[15px] mb-5 leading-relaxed" data-id="element-316">
                {card.description}
              </p>

              <ul className="space-y-3" data-id="element-317">
                {card.bullets.map((bullet, i) => <li key={i} className="flex items-start gap-2 text-[14px] text-white/90" data-id="element-318">
                    <Check className="text-lsa-celeste shrink-0 mt-0.5" size={18} data-id="element-319" />
                    <span data-id="element-320">{bullet}</span>
                  </li>)}
              </ul>
            </motion.div>)}
        </div>
      </div>
    </section>;
}